<template>
  <div>
    <FileUpload ref="fileUpload" @uploaded="replaceDoc" />
    <PTooltip label="Action impossible sur un document archivé" :disabled="!disabled" :delay="500" :offset="5">
      <button
        class="text-start w-full"
        @click="open"
        :data-sentry-id="`ReplaceDocBtn-${doc.id}`"
        :disabled="disabled"
        :class="{ 'text-grey-425 cursor-not-allowed': disabled }"
      >
        <OhVueIcon :name="replaceIcon" scale="0.83" />
        Remplacer par
      </button>
    </PTooltip>
  </div>
</template>

<script setup lang="ts">
import { FormOperation } from "@/app/types";
import { PTooltip, useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { HiSwitchHorizontal } from "oh-vue-icons/icons";
import { computed, ref } from "vue";
import { useNotifyAsyncOperation } from "../../../composable/useAsyncOperation";
import { type LetterFileDocumentDto } from "../../../dto/letter-file-document.dto";
import { useLetterFileDocumentApi } from "../../../http/letter-file-document.api";
import { useLetterFileStore } from "../../../stores/letter-file.store";
import FileUpload from "../file-upload.vue";

interface Props {
  doc: LetterFileDocumentDto;
  disabled: boolean;
}

const [replaceIcon] = useIcons(HiSwitchHorizontal);

const props = defineProps<Props>();
const emit = defineEmits<{ (e: "done"): void }>();

const letterFileStore = useLetterFileStore();
const letterFile = computed(() => letterFileStore.getCurrent());
const documentApi = useLetterFileDocumentApi();
const notifyAsyncOperation = useNotifyAsyncOperation();

const fileUpload = ref<InstanceType<typeof FileUpload> | null>(null);

function open() {
  fileUpload.value?.open();
}

async function replaceDoc(uploads: { fileId: number; file: File }[]) {
  const [uploaded] = uploads;
  if (!uploaded) return;
  await notifyAsyncOperation(async () => {
    await documentApi.replaceDocument(props.doc.id, letterFile.value!.id, uploaded.file.name, uploaded.fileId);
  }, FormOperation.DOCUMENT);
  emit("done");
}
</script>
